// iter278 — Verified App Links (assetlinks.json now matches the Play signing
// key) make Android open https://app.rvincente.it/* links INSIDE the app.
// That includes the Google OAuth redirect, which used to stay in Chrome:
// without this handler the code was never exchanged and the login spinner
// waited forever. Here we finish the exchange from the app itself; the
// LoginPage polling then picks up the result as before.
import { Capacitor } from '@capacitor/core';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CALLBACK_PATH = '/auth/google/callback';

async function handleUrl(url) {
  let u;
  try { u = new URL(url); } catch { return; }
  if (u.host !== window.location.host) return;

  if (u.pathname === CALLBACK_PATH) {
    const code = u.searchParams.get('code');
    const state = u.searchParams.get('state');
    if (!code || !state) return;
    const redirectUri = `${u.origin}${CALLBACK_PATH}`;
    const qs = new URLSearchParams({ code, redirect_uri: redirectUri, intent_id: state });
    try {
      await fetch(`${API}/auth/google/server-callback?${qs.toString()}`, { credentials: 'include' });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn('[appLinks] google callback failed:', e?.message);
    }
    return;
  }

  const og = u.pathname.match(/^\/api\/og\/partita\/(\d+)/);
  const target = og ? `/match/${og[1]}${u.search}` : u.pathname + u.search + u.hash;
  if (target !== window.location.pathname + window.location.search + window.location.hash) {
    window.location.assign(target);
  }
}

export async function listenAppLinks() {
  if (!Capacitor.isNativePlatform()) return;
  try {
    const { App } = await import('@capacitor/app');
    App.addListener('appUrlOpen', ({ url }) => { handleUrl(url); });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('[appLinks] listener unavailable:', e?.message);
  }
}
